import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import Accordion from 'react-bootstrap/Accordion';
import Modal from 'react-bootstrap/Modal';
import DatePicker from 'react-datepicker';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { getDetailsForAddPayments, addPayment } from '../../api/Payments';
import {
  getEarningsBetweenDateForPayments,
  getEarningsByRid,
  getNotPaidRedemptionsByMerchant,
} from '../../api/earning';
import { Pagination, Loading, PageHeader } from '../../components';
import Search from '../../components/Search/Search.component';
import DateFilter from '../../components/DateFilter/DateFilter.component';

import 'bootstrap/dist/css/bootstrap.min.css';
import styles from './addPayment.module.scss';

class AddPayment extends Component {
  redemptionTableRef = React.createRef(); // Drag select state

  state = {
    isApiCalled: false,
    loading: true,
    redemptionLoading: true,
    merchantName: '',
    merchantId: null,
    redemptionId: null,
    merchantIds: [],
    slicedMerchantIds: [],
    redemptionIds: [],
    redemptionOptions: [],
    mainTotal: 1,
    total: 1,
    mainCurrent: 0,
    current: 0,
    redemptionsFetched: false,
    redemptionError: '',
    isSuccess: false,
    addError: null,
    detailsError: '',
    isFiltered: true,
    isSearched: true,
    searching: false,
    filtering: false,
    search_filter_redemptions: [],
    isMerchantSearched: false,
    sliceStart: 0,
    sliceEnd: 10,
    merchantPages: 0,
    error: null,
    totalAmount: 0,
    searchedMerchant: null,
    searchedRedemption: null,
    showCancelModal: false,
    disableCancel: true,
    merchantpaginationIds: [],
    startDate: null,
    endDate: null,
    searchRedemptionId: '',
    paymentDate: null,
    searchMerchantName: '',
    searchMerchantId: '',
    referenceCode: '',
    emailNotification: true, // Email notification
    isDragging: false,
    startPoint: { x: 0, y: 0 },
    selectionBox: null,
    masterRedemptionMap: {},
    selectedRedemptions: {},
  };

  componentWillMount() {
    getDetailsForAddPayments(this.props.auth.token)
      .then((response) => {
        this.setState({
          merchantIds: response,
          loading: false,
          merchantName: response[0].name,
          merchantId: response[0].id,
          slicedMerchantIds: response.slice(
            this.state.sliceStart,
            this.state.sliceEnd
          ),
          merchantPages: this.getMerchantPage(response),
          merchantpaginationIds: response,
        });
        this.fetchRedemptionId(response[0].id, 0);
      })
      .catch((err) => {
        this.setState({
          loading: false,
          redemptionsFetched: true,
          detailsError: 'Merchant Ids fetch failed',
        });
        this.handleErrorCodes(err);
      });
  }

  getMerchantPage = (data) => {
    var merchantPage = 0;
    var mod = data.length % 10;
    if (mod > 0) {
      merchantPage = data.length / 10 - mod / 10 + 1;
    } else {
      merchantPage = data.length / 10;
    }
    return merchantPage;
  };

  fetchRedemptionId = (id, page) => {
    const request = {
      merchantId: id,
      page: page,
    };
    this.setState({ redemptionLoading: true });
    getNotPaidRedemptionsByMerchant(request, this.props.auth.token)
      .then((response) => {
        // Update master redemption map
        const newMap = { ...this.state.masterRedemptionMap };
        response.earnings.forEach((r) => {
          newMap[r.id] = r;
        });

        this.setState({
          redemptionIds: response.earnings,
          total: response.total,
          current: response.current,
          redemptionsFetched: true,
          mainCurrent: response.current,
          mainTotal: response.total,
          redemptionLoading: false,
          masterRedemptionMap: newMap,
        });
      })
      .catch((err) => {
        this.setState({
          redemptionsFetched: true,
          redemptionLoading: false,
        });
        this.handleErrorCodes(err);
      });
  };

  // Mouse down: start drag selection
  handleRedemptionMouseDown = (e) => {
    if (e.button !== 0) return;
    const rect = this.redemptionTableRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    this.setState({
      isDragging: true,
      startPoint: { x, y },
      selectionBox: { x, y, width: 0, height: 0 },
    });
    e.preventDefault();
  };

  // Mouse move: update selection box
  handleRedemptionMouseMove = (e) => {
    if (!this.state.isDragging) return;
    const rect = this.redemptionTableRef.current.getBoundingClientRect();
    const currX = e.clientX - rect.left;
    const currY = e.clientY - rect.top;
    this.setState({
      selectionBox: {
        x: Math.min(currX, this.state.startPoint.x),
        y: Math.min(currY, this.state.startPoint.y),
        width: Math.abs(currX - this.state.startPoint.x),
        height: Math.abs(currY - this.state.startPoint.y),
      },
    });
  };

  // Mouse up: finalize selection with toggle logic
  handleRedemptionMouseUp = () => {
    if (!this.state.isDragging || !this.state.selectionBox) return;
    this.setState({ isDragging: false });

    const { x, y, width, height } = this.state.selectionBox;
    const parentRect = this.redemptionTableRef.current.getBoundingClientRect();

    // Find all redemption rows
    const rows = Array.from(
      this.redemptionTableRef.current.querySelectorAll('tr[data-id]')
    );
    let updatedOptions = [...this.state.redemptionOptions];
    let updatedSelected = { ...this.state.selectedRedemptions };

    rows.forEach((row) => {
      const r = row.getBoundingClientRect();
      const rowX = r.left - parentRect.left;
      const rowY = r.top - parentRect.top;
      if (
        rowX < x + width &&
        rowX + r.width > x &&
        rowY < y + height &&
        rowY + r.height > y
      ) {
        const id = row.getAttribute('data-id');
        const isChecked = updatedOptions.includes(id);
        // Toggle as per drag: if already checked, unselect; if not, select
        if (!isChecked) {
          // Select
          updatedOptions.push(id);
          const redemption = this.state.masterRedemptionMap[id];
          if (redemption) updatedSelected[id] = redemption;
        } else {
          // Unselect
          updatedOptions = updatedOptions.filter((item) => item !== id);
          delete updatedSelected[id];
        }
      }
    });

    const allSelected = Object.values(updatedSelected);
    const currentTotal = allSelected.reduce(
      (sum, redemption) => sum + (redemption.earnedAmount || 0),
      0
    );

    this.setState({
      redemptionOptions: updatedOptions,
      selectedRedemptions: updatedSelected,
      totalAmount: currentTotal,
      redemptionError: '',
      addError: null,
      disableCancel: false,
      selectionBox: null,
    });
  };

  handleSearch = async (input, page) => {
    if (input) {
      const item = this.state.redemptionIds.filter((item) => {
        var itemData = item.id;
        return itemData.indexOf(input) > -1;
      });
      if (item.length !== 0 && input.length === 10) {
        const newMap = { ...this.state.masterRedemptionMap };
        item.forEach((r) => {
          newMap[r.id] = r;
        });
        this.setState({
          isSearched: true,
          searching: true,
          filtering: false,
          search_filter_redemptions: item,
          searchedRedemption: `found with ID ${input}`,
          total: this.getMerchantPage(item),
          current: 0,
          masterRedemptionMap: newMap,
        });
      } else {
        const merchantId = this.state.merchantId;
        const token = this.props.auth.token;
        const param = {
          page: page ? page : 0,
          redemptionid: input,
          selectIdType: 'REDEMPTION_ID_FOR_PAYMENT',
        };
        this.setState({
          isSearched: false,
          addError: null,
          searchedRedemption: `found with ID ${input}`,
        });
        try {
          const response = await getEarningsByRid(merchantId, token, param);
          const newMap = { ...this.state.masterRedemptionMap };
          response.earnings.forEach((r) => {
            newMap[r.id] = r;
          });
          this.setState({
            isSearched: true,
            searching: true,
            filtering: false,
            search_filter_redemptions: response.earnings,
            total: response.total,
            current: response.current,
            masterRedemptionMap: newMap,
          });
        } catch (error) {
          this.setState({
            isSearched: true,
            searching: true,
            filtering: false,
          });
          this.handleErrorCodes(error);
        }
      }
    }
  };

  handleFilter = (start, end, page) => {
    const merchantId = this.state.merchantId;
    const token = this.props.auth.token;
    const startx = moment(start).startOf('day').format('YYYY-MM-DD HH:mm:ss');
    const endx = moment(end).endOf('day').format('YYYY-MM-DD HH:mm:ss');
    const param = {
      page: page ? page : 0,
      startDate: startx,
      endDate: endx,
    };

    this.setState({
      isFiltered: false,
      searching: false,
      filtering: true,
      disableCancel: false,
    });
    getEarningsBetweenDateForPayments(merchantId, token, param)
      .then((response) => {
        const newMap = { ...this.state.masterRedemptionMap };
        response.earnings.forEach((r) => {
          newMap[r.id] = r;
        });
        this.setState({
          search_filter_redemptions: response.earnings,
          total: response.total,
          current: response.current,
          isFiltered: true,
          searchedRedemption: `for ${moment(start).format(
            'DD/MM/YYYY'
          )} - ${moment(end).format('DD/MM/YYYY')}`,
          masterRedemptionMap: newMap,
        });
      })
      .catch((err) => {
        this.setState({
          isFiltered: true,
          search_filter_redemptions: [],
          searchedRedemption: `Found Between ${moment(start).format(
            'DD/MM/YYYY'
          )} - ${moment(end).format('DD/MM/YYYY')}`,
        });
        this.handleErrorCodes(err);
      });
  };

  handleOnSubmit = () => {
    this.setState({
      isApiCalled: true,
      addError: null,
      disableCancel: true,
    });

    const {
      referenceCode,
      redemptionOptions,
      merchantId,
      paymentDate,
      emailNotification,
    } = this.state;

    // Validation
    if (redemptionOptions.length === 0) {
      const msg = 'Select at least one redemption to continue';
      this.setState({
        isApiCalled: false,
        addError: msg,
        disableCancel: false,
      });
      this.showErrorMessage(msg);
      return;
    }
    if (!referenceCode.trim()) {
      const msg = 'Reference code is mandatory';
      this.setState({
        isApiCalled: false,
        addError: msg,
        disableCancel: false,
      });
      this.showErrorMessage(msg);
      return;
    }

    // Prepare request
    const redemptions = redemptionOptions.map((rdId) => +rdId);
    const request = {
      merchantId,
      redemptionIds: redemptions,
      paymentDate,
      notifyMerchantViaEmail: emailNotification,
      referenceCode,
    };

    addPayment(request, this.props.auth.token)
      .then((response) => {
        if (response.status === 'MERCHANT_PAYABLE_ADDED_SUCCESSFULLY') {
          this.setState({
            isSuccess: true,
            redemptionOptions: [],
            totalAmount: 0,
            disableCancel: false,
            referenceCode: '',
            selectedRedemptions: {},
          });
          this.showSuccessMessage();
        }
        this.setState({
          isApiCalled: false,
        });
        this.fetchRedemptionId(merchantId, 0);
      })
      .catch((err) => {
        this.setState({
          isApiCalled: false,
          addError: 'Add payment unsuccessful',
          disableCancel: false,
        });
        this.showErrorMessage('Add payment unsuccessful');
        this.handleErrorCodes(err);
      });
  };

  handleErrorCodes = (error) => {
    let errorMessage;
    switch (error.message) {
      case 'MERCHANT_NOT_FOUND':
        errorMessage = 'Invalid request. Please try again';
        break;
      case 'REDEMPTION_NOT_FOUND':
        errorMessage = 'Invalid request. Please try again';
        break;
      case 'MERCHANT_MISMATCH':
        errorMessage = "Redemption's merchant and request merchant mismatch";
        break;
      default:
        errorMessage = error.message;
    }
    this.showErrorMessage(errorMessage);
  };

  // Show error message
  showErrorMessage = (err) => {
    toast.error(err, {
      position: 'bottom-right',
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
    });
  };

  // Show success message
  showSuccessMessage = () => {
    toast.success('Add payment successful', {
      position: 'bottom-right',
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
    });
  };

  handleMerchantIdOnChange = (name, id) => {
    this.setState({
      merchantId: id,
      merchantName: name,
      redemptionsFetched: false,
      isSuccess: false,
      searching: false,
      filtering: false,
      disableCancel: false,
      addError: '',
      totalAmount: 0,
      redemptionOptions: [],
      selectedRedemptions: {},
    });
    this.fetchRedemptionId(id, 0);
  };

  // Handle individual redemption checkbox toggle
  handleRedemptionCheck = (id, amount, checked) => {
    // Toggle selection
    let options = [...this.state.redemptionOptions];
    let selectedRedemptions = { ...this.state.selectedRedemptions };

    // Always fetch from masterRedemptionMap
    const redemption = this.state.masterRedemptionMap[id];

    if (checked) {
      if (!options.includes(id)) {
        options.push(id);
        if (redemption) selectedRedemptions[id] = redemption;
      }
    } else {
      options = options.filter((item) => item !== id);
      delete selectedRedemptions[id];
    }

    const allSelected = Object.values(selectedRedemptions);
    const currentTotal = allSelected.reduce(
      (sum, redemption) => sum + (redemption.earnedAmount || 0),
      0
    );

    this.setState({
      totalAmount: currentTotal,
      redemptionOptions: options,
      selectedRedemptions,
      redemptionError: '',
      addError: null,
      disableCancel: false,
    });
  };

  // Handle select all redemptions
  handleSelectAllRedemptions = (checked) => {
    const allRedemptions =
      this.state.searching || this.state.filtering
        ? this.state.search_filter_redemptions
        : this.state.redemptionIds;

    let options = [...this.state.redemptionOptions];
    let selectedRedemptions = { ...this.state.selectedRedemptions };

    if (checked) {
      allRedemptions.forEach((item) => {
        if (!options.includes(item.id)) {
          options.push(item.id);
          // Use from master map for accuracy
          const redemption = this.state.masterRedemptionMap[item.id] || item;
          selectedRedemptions[item.id] = redemption;
        }
      });
    } else {
      allRedemptions.forEach((item) => {
        options = options.filter((id) => id !== item.id);
        delete selectedRedemptions[item.id];
      });
    }

    const uniqueOptions = Array.from(new Set(options));
    const allSelected = Object.values(selectedRedemptions);

    const currentTotal = allSelected.reduce(
      (sum, redemption) => sum + (redemption.earnedAmount || 0),
      0
    );

    this.setState({
      totalAmount: currentTotal,
      redemptionOptions: uniqueOptions,
      selectedRedemptions,
      redemptionError: '',
      addError: null,
      disableCancel: false,
    });
  };

  selectAllRedemption = (checked) => {
    let xxx = this.state.redemptionIds;
    let options = this.state.redemptionOptions;
    let currentTotal = this.state.totalAmount;

    if (checked) {
      options.push(...xxx.map((item) => item.id));
      currentTotal += xxx.reduce((prev, curr) => {
        return (prev += curr.earnedAmount);
      }, 0);
    } else {
      options = options.filter(
        (item) => !xxx.find((item2) => item2.id === item)
      );
      currentTotal -= xxx.reduce((prev, curr) => {
        return (prev += curr.earnedAmount);
      }, 0);
    }

    this.setState({
      totalAmount: currentTotal,
      redemptionOptions: options,
      redemptionError: '',
      addError: null,
      disableCancel: false,
    });
  };

  handlePagination = (page) => {
    if (this.state.searching) {
      this.handleSearch(this.state.searchRedemptionId, page);
    } else if (this.state.filtering) {
      this.handleFilter(this.state.startDate, this.state.endDate, page);
    } else {
      this.fetchRedemptionId(this.state.merchantId, page);
    }
  };

  handleClear = () => {
    this.setState({
      search_filter_redemptions: [],
      isSearched: true,
      isFiltered: true,
      searching: false,
      filtering: false,
      total: this.state.mainTotal,
      current: this.state.mainCurrent,
      searchRedemptionId: '',
    });
  };

  handleMerchantSearch = (id) => {
    if (id) {
      const item = this.state.merchantIds.filter(
        (item) => item.id.indexOf(id) > -1
      );

      this.setState({
        slicedMerchantIds: item.slice(0, 10),
        isMerchantSearched: true,
        searchedMerchant: `found with ID ${id}`,
        merchantpaginationIds: item,
        merchantPages: this.getMerchantPage(item),
        searchMerchantName: '',
      });
    }
  };

  handleMerchantNameSearch = (name) => {
    if (name) {
      const item = this.state.merchantIds.filter((item) => {
        let itemData = item.name.toLowerCase();
        return itemData.indexOf(name.toLowerCase()) > -1;
      });

      this.setState({
        slicedMerchantIds: item.slice(0, 10),
        isMerchantSearched: true,
        searchedMerchant: `found as ${name}`,
        merchantpaginationIds: item,
        merchantPages: this.getMerchantPage(item),
        searchMerchantId: '',
      });
    }
  };

  handleMerchantPagination = (page) => {
    if (page > 0) {
      const sliceStart = page * 10;
      const sliceEnd = (page + 1) * 10;
      this.setState({
        sliceStart,
        sliceEnd,
        slicedMerchantIds: this.state.merchantpaginationIds.slice(
          sliceStart,
          sliceEnd
        ),
      });
    } else {
      const sliceStart = 0;
      const sliceEnd = 10;
      this.setState({
        sliceStart,
        sliceEnd,
        slicedMerchantIds: this.state.merchantpaginationIds.slice(
          sliceStart,
          sliceEnd
        ),
      });
    }
  };

  handleMerchantsClear = () => {
    this.setState({
      slicedMerchantIds: this.state.merchantIds.slice(0, 10),
      isMerchantSearched: false,
      searchedMerchant: null,
      merchantpaginationIds: this.state.merchantIds,
      merchantPages: this.getMerchantPage(this.state.merchantIds),
    });
  };

  handleRedemptionFilterClear = () => {
    this.setState({
      startDate: null,
      endDate: null,
      filtering: false,
      search_filter_redemptions: [],
      total: this.state.mainTotal,
    });
  };

  handlePopupState = (boolean) => {
    this.setState({
      showCancelModal: boolean,
    });
  };

  handleCancelPayment = () => {
    this.setState({
      showCancelModal: false,
      redemptionOptions: [],
      totalAmount: 0,
      addError: null,
      referenceCode: '',
      paymentDate: null,
      selectedRedemptions: {},
    });
  };

  renderErrorMessage = (err) => {
    return <small className={styles.err}>{err}</small>;
  };

  renderSuccessMessage = () => {
    return <span className={styles.success}>Add payment successful</span>;
  };

  renderInputField = (placeholder, value, onChange) => {
    return (
      <Form.Control
        placeholder={placeholder}
        aria-label={placeholder}
        value={value}
        onChange={onChange}
      />
    );
  };

  renderNotAvailable = (item) => {
    return (
      <div className='text-center'>
        <span>{item}</span>
      </div>
    );
  };

  renderLoadAllBtn = (onClick) => {
    return (
      <Button variant='outline-primary' type='submit' onClick={onClick}>
        Load All
      </Button>
    );
  };

  // Render redemption rows with multiple select checkboxes
  renderRedemptions = (data) => {
    return data.map((option) => {
      const isChecked = this.state.redemptionOptions.includes(option.id); // Check if this redemption is selected
      return (
        <tr className={styles.data} key={option.id} data-id={option.id}>
          <td>
            <input
              type='checkbox'
              name={'redemption_' + option.id}
              onChange={() => {
                this.handleRedemptionCheck(
                  // Handle individual redemption checkbox toggle
                  option.id,
                  option.earnedAmount,
                  isChecked
                );
              }}
              value={option.id}
              checked={isChecked}
            />
          </td>
          <td>
            <span value={option} id={option.id}>
              {moment(option.dateTime).format('DD/MM/YYYY hh:mm A')}
            </span>
          </td>
          <td>
            <span value={option} id={option.id}>
              {option.id}
            </span>
          </td>
          <td>
            <span value={option} id={option.id}>
              {option.earnedAmount &&
                option.earnedAmount
                  .toFixed(2)
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            </span>
          </td>
        </tr>
      );
    });
  };

  handleOnStartDateChange = (startDate) => {
    this.setState({ startDate: startDate });
  };
  handleOnEndDateChange = (endDate) => {
    this.setState({ endDate: endDate });
  };
  handleOnSearchRedemptionIdChange = (value) => {
    this.setState({ searchRedemptionId: value });
  };

  handleSearchMerchantsNameChange = (value) => {
    this.setState({ searchMerchantName: value });
  };

  handleSearchMerchantIdChange = (value) => {
    this.setState({ searchMerchantId: value });
  };

  // --- Payment Notification feature ---
  handleEmailNotificationChange = (event) => {
    this.setState({ emailNotification: event.target.checked });
  };

  renderRedemptionsDrawer = () => {
    // Determine which redemptions are currently shown
    const currentRedemptions =
      this.state.searching || this.state.filtering
        ? this.state.search_filter_redemptions
        : this.state.redemptionIds;
    const allSelected =
      currentRedemptions.length > 0 &&
      currentRedemptions.every((item) =>
        this.state.redemptionOptions.includes(item.id)
      );
    return (
      <div className={styles.drawer_div}>
        {/* Move DateFilter and Search outside the table */}
        <div className={styles.table_search} style={{ marginBottom: '16px' }}>
          <DateFilter
            label='Period'
            onBtnPress={this.handleFilter}
            onClear={this.handleRedemptionFilterClear}
            onStartDateChange={this.handleOnStartDateChange}
            onEndDateChange={this.handleOnEndDateChange}
          />
          <Search
            placeholder='Redemption ID'
            onBtnPress={this.handleSearch}
            onClearPress={this.handleClear}
            max={10}
            onChangeKey={this.handleOnSearchRedemptionIdChange}
          />
        </div>
        {this.state.redemptionIds.length === 0 ? (
          <span>No Redemption Available</span>
        ) : (
          <div
            ref={this.redemptionTableRef}
            style={{ position: 'relative' }}
            onMouseDown={this.handleRedemptionMouseDown}
            onMouseMove={this.handleRedemptionMouseMove}
            onMouseUp={this.handleRedemptionMouseUp}
          >
            {/* Selection box overlay */}
            {this.state.selectionBox && (
              <div
                className={styles.selectionBox}
                style={{
                  left: this.state.selectionBox.x,
                  top: this.state.selectionBox.y,
                  width: this.state.selectionBox.width,
                  height: this.state.selectionBox.height,
                }}
              />
            )}
            <Table>
              <thead className={styles.table_head}>
                <tr>
                  <th>
                    <input
                      type='checkbox'
                      name='selectAllRedemptions'
                      checked={allSelected}
                      onChange={(event) => {
                        this.handleSelectAllRedemptions(event.target.checked);
                      }}
                    />
                  </th>
                  <th>Date</th>
                  <th>Redemption ID</th>
                  <th>Amount (LKR)</th>
                </tr>
              </thead>
              <tbody>
                {!this.state.isFiltered || !this.state.isSearched ? (
                  <tr>
                    <td colSpan={4}>
                      <Loading text='Loading' />
                    </td>
                  </tr>
                ) : currentRedemptions.length > 0 ? (
                  this.renderRedemptions(currentRedemptions)
                ) : (
                  <tr>
                    <td colSpan={4}>
                      {this.renderNotAvailable(
                        `No redemptions ${this.state.searchedRedemption}`
                      )}
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        )}
        {this.state.total > 1 ? (
          <Pagination
            pageCount={this.state.total}
            onChange={this.handlePagination}
            currentPage={this.state.current}
          />
        ) : null}
      </div>
    );
  };

  renderMerchantDrawer = () => {
    return (
      <div className={styles.merchantDrawer_div}>
        {this.state.merchantIds.length === 0 ? (
          <span>No Merchants Available</span>
        ) : (
          <div>
            <Table>
              <thead>
                <tr>
                  <th className={styles.table_filter_search} colSpan={3}>
                    <div className={styles.table_search}>
                      <Search
                        placeholder='Merchant Name'
                        onBtnPress={this.handleMerchantNameSearch}
                        onClearPress={this.handleMerchantsClear}
                        max={20}
                        handleValueFromParent
                        value={this.state.searchMerchantName}
                        onChange={this.handleSearchMerchantsNameChange}
                      />
                      <Search
                        placeholder='Merchant Id'
                        onBtnPress={this.handleMerchantSearch}
                        onClearPress={this.handleMerchantsClear}
                        max={50}
                        handleValueFromParent
                        value={this.state.searchMerchantId}
                        onChange={this.handleSearchMerchantIdChange}
                      />
                    </div>
                  </th>
                </tr>
              </thead>
              <thead>
                <tr>
                  <th></th>
                  <th>Name</th>
                  <th>ID</th>
                </tr>
              </thead>
              <tbody>
                {this.state.slicedMerchantIds.length > 0
                  ? this.state.slicedMerchantIds.map((option) => (
                      <tr className={styles.data} key={option.id}>
                        <td>
                          <input
                            type='radio'
                            name='option'
                            onChange={() => {
                              this.handleMerchantIdOnChange(
                                option.name,
                                option.id
                              );
                            }}
                            value={option.id}
                            checked={
                              this.state.merchantId &&
                              this.state.merchantId === option.id
                            }
                          />
                        </td>
                        <td>
                          <span value={option} id={option.id}>
                            {option.name}
                          </span>
                        </td>
                        <td>
                          <span value={option} id={option.id}>
                            {option.id}
                          </span>
                        </td>
                      </tr>
                    ))
                  : null}
              </tbody>
            </Table>
            {this.state.isMerchantSearched ? (
              <div className={styles.not_available}>
                {this.state.slicedMerchantIds.length === 0
                  ? this.renderNotAvailable(
                      `No merchant ${this.state.searchedMerchant}`
                    )
                  : null}
              </div>
            ) : null}
          </div>
        )}
        {this.state.merchantpaginationIds.length > 10 && (
          <Pagination
            pageCount={this.state.merchantPages}
            onChange={this.handleMerchantPagination}
            currentPage={0}
          />
        )}
      </div>
    );
  };

  renderCancelPopup = () => {
    return (
      <Modal
        show={this.state.showCancelModal}
        onHide={() => {
          this.handlePopupState(false);
        }}
        backdrop='static'
        keyboard={false}
        animation={false}
        aria-labelledby='contained-modal-title-vcenter'
        centered
      >
        <Modal.Header>
          <Modal.Title>Cancel</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>Are you sure you want to cancel ? </p>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant='secondary'
            onClick={() => {
              this.handlePopupState(false);
            }}
          >
            No
          </Button>
          <Button variant='primary' onClick={this.handleCancelPayment}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  handleOnPaymentDateChange = (date) => {
    this.setState({ paymentDate: date });
  };

  handleReferenceCodeOnChange = (event) => {
    this.setState({ referenceCode: event.target.value });
  };

  render() {
    return (
      <div className={styles.div_root}>
        <ToastContainer />
        <PageHeader text='Add Payment' />
        <Accordion defaultActiveKey='0' className={styles.accordion}>
          <Card>
            <Card.Header>
              <Accordion.Toggle as={Button} variant='link' eventKey='0'>
                Select Merchant Here
              </Accordion.Toggle>
            </Card.Header>

            <Accordion.Collapse eventKey='0'>
              <Card.Body>
                {this.state.loading ? (
                  <Loading text='Loading' />
                ) : (
                  this.renderMerchantDrawer()
                )}
              </Card.Body>
            </Accordion.Collapse>
          </Card>

          <Card>
            <Card.Header>
              <Accordion.Toggle as={Button} variant='link' eventKey='1'>
                {`Select Redemptions of ${this.state.merchantName} Here`}
              </Accordion.Toggle>
            </Card.Header>

            <Accordion.Collapse eventKey='1'>
              <Card.Body>
                {this.state.redemptionLoading ? (
                  <Loading text='Loading' />
                ) : (
                  this.renderRedemptionsDrawer()
                )}
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>

        <Card className={styles.amount_payable_div}>
          <span className={styles.amount_payable_line01}>
            {`Number of redemption(s) selected : ${this.state.redemptionOptions.length}`}
          </span>
          <span className={styles.amount_payable}>
            {`Total amount to pay : LKR ${this.state.totalAmount
              .toFixed(2)
              .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
          </span>
        </Card>

        <div className='text-center'>
          {this.state.isSuccess
            ? this.renderSuccessMessage()
            : this.state.addError &&
              this.renderErrorMessage(this.state.addError)}
        </div>

        {this.renderCancelPopup()}

        <div className={styles.div_payment_details}>
          <div>
            <label>
              Reference Code <span style={{ color: 'red' }}>*</span>
            </label>
            <Form.Control
              placeholder='Reference code'
              value={this.state.referenceCode}
              onChange={this.handleReferenceCodeOnChange}
              required
            />
          </div>
          <div>
            <label>Payment Date</label>
            <DatePicker
              className='form-control'
              selected={this.state.paymentDate}
              onChange={this.handleOnPaymentDateChange}
              selectsStart
              startDate={null}
              endDate={null}
              maxDate={Date.now()}
              placeholderText={moment(Date.now()).format('DD/MM/YYYY')}
              isClearable
              dateFormat='dd/MM/yyyy'
            />
          </div>
        </div>

        {/* Payment notification checkbox */}
        <div className={styles.btn_email_notification}>
          <Form.Check
            type='checkbox'
            name='emailNotification'
            label='Send email notification to merchant'
            checked={this.state.emailNotification}
            onChange={this.handleEmailNotificationChange}
            style={{ display: 'inline-block' }}
          />
        </div>

        <div className={styles.bottomBtn}>
          <div className={styles.div_addBtn}>
            <Button
              variant='secondary'
              block
              onClick={() => {
                this.handlePopupState(true);
              }}
              disabled={this.state.disableCancel}
            >
              CANCEL
            </Button>
          </div>
          <div className={styles.div_addBtn}>
            <Button
              variant='dark'
              block
              onClick={this.handleOnSubmit}
              disabled={this.state.loading}
            >
              {this.state.isApiCalled ? 'Loading..' : 'ADD PAYMENT'}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth.auth,
  };
};

export default connect(mapStateToProps)(AddPayment);
